import "./Footer.css"
import { Link } from "react-router-dom"
function Footer(){
    return(
        <>
        <div className="footerFather">
            <div className="footerSector" id="footer1"><Link to="/"><p>Inicio</p></Link><Link to="/privacyPolicy"><p>Politicas de Privacidad</p></Link><Link to="/myInfo"><p>Mis Datos</p></Link></div>
            <div className="footerSector" id="footer1"></div>
            <div className="footerSector" id="footer1"></div>
        </div>
        </>
    )
}

export default Footer